import { Injectable } from '@angular/core';

import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonService } from 'src/app/shared/utils/common.service';

@Injectable({
  providedIn: 'root'
})
export class MantenedorParametrosRaspberryService {

  tvcModulo: any = {};
  urlTvc: any = {};
  url: string;

  constructor(
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.tvcModulo = moduloPerform;
    this.urlTvc = this.tvcModulo.url.raspberry;
    this.url = this._util.getQueryTvc('');
  }

  getAllParam() {
    console.log(this.url + this.urlTvc.mainParam);
    return this._commom.peticionGetConHeader(this.url + this.urlTvc.mainParam);
  }

  createRaspberry(innObjRaspberry: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.mainParam, innObjRaspberry);
  }

  updateRaspberry(innObjRaspberry: any) {
    return this._commom.peticionPutConHeader(this.url + this.urlTvc.mainParam, innObjRaspberry);
  }

  deleteRaspberry(innIpRaspberry: string) {
    return this._commom.peticionDeleteConHeader(this.url + this.urlTvc.mainParam + `/${innIpRaspberry}`);
  }

  getAllParamsByRaspberry(innIpRaspberry: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.mainConfig+'/linea' ,innIpRaspberry);
  }

  getAllParamsByRaspberryAny(innIpRaspberry: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.mainConfig+'/getall',innIpRaspberry);
  }

  deleteConfigRaspberryByLinea(innIpRaspberry: any){
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.mainConfig+'/delete',innIpRaspberry);
  }

  getCantidadGuardadoPorlinea(innIpRaspberry: any){
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.main+'/cantidad',innIpRaspberry);
  }

  createParametrizacionRaspberry(innIpRaspberry: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.mainConfig ,innIpRaspberry);
  }

  getReporteByrespberry() {
    return this._commom.peticionGetConHeader(this.url + this.urlTvc.raspberry);
  }

  getEstadoLiveRaspberry(innIpRaspberry: any){
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.health,innIpRaspberry);
  }

  getEstadoReadyRaspberry(innIpRaspberry: any){
    return this._commom.peticionPostConHeader(this.url + this.urlTvc.health,innIpRaspberry);
  }
}
